/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $ = _ref.$,
      $f7 = _ref.$f7,
      $update = _ref.$update;
  // Login screen demo data
  var username = '';
  var password = '';

  var historyClick = function historyClick(e) {
    $(".page-content-history").scrollTop(10000);
  };

  var updateUsername = function updateUsername(e) {
    username = e.target.value;
    $update();
  };

  var updatePassword = function updatePassword(e) {
    password = e.target.value;
    $update();
  };

  var alertLoginData = function alertLoginData() {
    $f7.dialog.alert('Username: ' + username + '<br/>Password: ' + password, function () {
      $f7.loginScreen.close();
    });
  };

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div id="app">

    <!-- Left panel with cover effect-->
    <div class="panel panel-left panel-cover theme-dark panel-init">
      <div class="view">
        <div class="page">
          <div class="navbar">
            <div class="navbar-bg"></div>
            <div class="navbar-inner">
              <div class="title">Left Panel</div>
            </div>
          </div>
          <div class="page-content">
            <div class="block">Left panel content goes here</div>
          </div>
        </div>
      </div>
    </div>
    <!-- Right panel with reveal effect-->
    <div class="panel panel-right panel-reveal theme-dark">
      <div class="view">
        <div class="page">
          <div class="navbar">
            <div class="navbar-bg"></div>
            <div class="navbar-inner">
              <div class="title">FAQ</div>
            </div>
          </div>
          <div class="page-content">
            <div class="block">Explaination</div>
          </div>
        </div>
      </div>
    </div>

    <!-- Views/Tabs container -->
    <div class="views tabs safe-areas">
      <!-- Tabbar for switching views-tabs -->
      <div class="toolbar toolbar-bottom tabbar-labels">
        <div class="toolbar-inner">
          <a href="#view-account" class="tab-link">
            <i class="icon f7-icons">person_crop_square_fill</i>
            <span class="tabbar-label">Account</span>
          </a>
          <a href="#view-home" class="tab-link tab-link-active">
            <!-- <i class="icon material-icons ">wallet</i> -->
            <i class="icon f7-icons" >chart_bar_fill</i>
            <span class="tabbar-label">Trade</span>
          </a>
          <a href="#view-history" class="tab-link" @click="${historyClick}">
            <i class="icon f7-icons">tray</i>
            <span class="tabbar-label">History</span>
          </a>
          <a href="#view-news" class="tab-link">
            <i class="icon f7-icons">square_list</i>
            <span class="tabbar-label">News</span>
          </a>

        </div>
      </div>

      <!-- Your main view/tab, should have "view-main" class. It also has "tab-active" class -->
      <div id="view-home" class="view view-main view-init tab tab-active" data-url="/">
        <!-- Home page will be loaded here dynamically from / route -->
      </div>

      <!-- Catalog View -->
      <div id="view-history" class="view view-init tab" data-name="history" data-url="/historyV2/">
        <!-- Catalog page will be loaded here dynamically from /catalog/ route -->
      </div>

      <!-- Catalog View -->
      <div id="view-news" class="view view-init tab" data-name="news" data-url="/news/">
        <!-- Catalog page will be loaded here dynamically from /catalog/ route -->
      </div>

      <!-- Settings View -->
      <div id="view-account" class="view view-init tab" data-name="account" data-url="/account/">
        <!-- Settings page will be loaded here dynamically from /settings/ route -->
      </div>
    </div>


    <!-- Popup -->
    <div class="popup" id="my-popup">
      <div class="view">
        <div class="page">
          <div class="navbar">
            <div class="navbar-bg"></div>
            <div class="navbar-inner">
              <div class="title">Popup</div>
              <div class="right">
                <a href="#" class="link popup-close">Close</a>
              </div>
            </div>
          </div>
          <div class="page-content">
            <div class="block">
              <p>Popup content goes here.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Login Screen -->
    <div class="login-screen" id="my-login-screen">
      <div class="view">
        <div class="page">
          <div class="page-content login-screen-content">
            <div class="login-screen-title">Login</div>
            <div class="list">
              <ul>
                <li class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">Username</div>
                    <div class="item-input-wrap">
                      <input type="text" name="username" placeholder="Your username" value="${username}" @input="${updateUsername}"/>

                    </div>
                  </div>
                </li>
                <li class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-title item-label">Password</div>
                    <div class="item-input-wrap">
                      <input type="password" name="password" placeholder="Your password" value="${password}" @input="${updatePassword}"/>

                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div class="list">
              <ul>
                <li>
                  <a href="#" class="item-link list-button login-button" @click="${alertLoginData}">Sign In</a>

                </li>
              </ul>
              <div class="block-footer">Some text about login information.<br/>Click "Sign In" to close Login Screen</div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
`
    }
    ;
}

framework7Component.id = '11bbccdbb1';
export default framework7Component;